<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" (click)="scrollToTop()">
  <span id="toTheTopButton" matTooltip="To the top" class="material-icons unselectable">arrow_upward</span>
</div>
